export enum StorageKeys {
  prefix = 'construcys-dataviz',
  temporary = 'tmpStorage',
}
